import * as angular from 'angular';
import { app } from '../../../../../app';

/**
 * Service for profile photo upload.
 */
app.factory('PhotoUploadService', PhotoUploadService);

/** @ngInject */
function PhotoUploadService($http) {
    return {
        upload: function (file, id, uploadUrl, successAction, errorAction) {
            var fd = new FormData();
            fd.append('file', file);

            $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                },
            })
                .then((response) => successAction(response.data))
                .catch((response) => errorAction(response.data));
        },
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/overview/photo-upload.service.js